import React, { useState } from 'react';
import { Formik, Field, FormikActions } from 'formik';
import { connect } from 'react-redux';
import { required, isEmail, isPhone } from 'utils/formValidators';
import { normalizePhone, getTip } from 'utils/helpers';
import { toastr } from 'react-redux-toastr';
import queryString from 'query-string';
import { USER_ROLES } from "enums/userRoles";

import TextField from 'components/TextField';
import InstructionsForRegistration from './InstructionsForRegistration';
import RecaptchaField from 'components/RecaptchaField';

import * as API from 'api/regRequest';
import { IRootState } from 'reducers';
import { RouteProps } from 'react-router';

interface IValues {
  first_name: string;
  patronymic: string;
  second_name: string;
  phonenumber: string;
  email: string;
  company: string;
  position: string;
  comment: string;
}

interface IProps {
  tips: { [key: string]: string };
  userRole: number;
}

const RegistrationPage: React.FC<IProps & RouteProps> = ({
  tips,
  location,
  userRole,
}) => {
  // const [isModalVisible, toggleModal] = useState(false);

  const [showForm, toggleForm] = useState(true);

  // const showModal = () => toggleModal(true);
  // const hideModal = () => toggleModal(false);

  const submit = (values: IValues, { setSubmitting, resetForm }: FormikActions<IValues>) => {
    const urlParams = queryString.parse(location!.search);

    const convertedValues = {
      ...values,
      phonenumber: `+${normalizePhone(values.phonenumber)}`,
      referalCode: urlParams.ref,
      role: location!.pathname === '/auth/registration' ? USER_ROLES.CAR_AGENT : USER_ROLES.NDV_AGENT,
    };

    API.createRegRequest(convertedValues).then((response: any = {}) => {
      if (response.success) {
        toggleForm(false);
        resetForm();
      } else {
        toastr.error(response.error || getTip(8)(tips), '');
      }
      setSubmitting(false);
    });
  }

  const formValidate = ({ company, position, comment }: IValues) => {
    let errors: { [key: string]: string } = {};

    // TODO: write proper validation
    if (!comment && (!company || !position)) {
      errors.comment = 'error';
      errors.position = 'error';
      errors.company = 'error';
    }

    return errors;
  }

  return (
    <React.Fragment>
      {showForm ? (
      <div className="container mobile-container">
        <div className="reg">
          <div className="row">
            <div className="col-12 mb-4">
              <h2 className="reg__title text-center">Регистрация</h2>
            </div>
            <Formik
              initialValues={{
                first_name: '',
                patronymic: '',
                second_name: '',
                phonenumber: '',
                email: '',
                company: '',
                position: '',
                comment: '',
              }}
              onSubmit={submit}
              validate={formValidate}
              render={({ errors, touched, isValidating, isSubmitting, submitForm, handleReset }) => (
                <React.Fragment>
                  <div className="col-12 col-lg-6 pr-lg-4 registration-mobile-style">
                    <form>
                      <div className="form-group row no-gutters">
                        <div className="col-12">
                          <Field
                            name="second_name"
                            placeholder="Фамилия*"
                            component={TextField}
                            validate={required}
                          />
                        </div>
                        <div className="col-12">
                          <Field
                            name="first_name"
                            placeholder="Имя"
                            component={TextField}
                            validate={required}
                          />
                        </div>
                        <div className="col-12">
                          <Field
                            name="patronymic"
                            placeholder="Отчество"
                            component={TextField}
                            validate={required}
                          />
                        </div>
                        <div className="col-12 col-md-6 pr-1 registration-mobile-style">
                          <Field
                            name="phonenumber"
                            validate={isPhone}
                            mask="+7 (999) 999-99-99"
                            placeholder="Номер телефона"
                            type="tel"
                            // alwaysShowMask={true}
                            component={TextField}
                          />
                        </div>
                        <div className="col-12 col-md-6 pl-1 registration-mobile-style">
                          <Field
                            name="email"
                            placeholder="E-mail"
                            component={TextField}
                            validate={isEmail}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-12 col-lg-6 pl-lg-4 registration-mobile-style">
                    <form>
                      <div className="form-group row">
                        <div className="col-12 registration-mobile-style">
                          <Field
                            name="company"
                            placeholder="Компания"
                            component={TextField}
                          />
                        </div>
                        <div className="col-12 registration-mobile-style">
                          <Field
                            name="position"
                            placeholder="Должность"
                            component={TextField}
                          />
                        </div>
                        <div className="col-12 registration-mobile-style">
                          <Field name="comment" placeholder="Кому вы планируете продавать?" component="textarea"/>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-12 text-center registration-mobile-style">
                    <div className="col-12 capcha-center">
                      <Field
                        name="recaptcha"
                        component={RecaptchaField}
                        validate={required}
                      />
                    </div>
                    <button onClick={submitForm} className="btn mt-2 registration-send" disabled={isSubmitting}>Отправить</button>
                    <a onClick={handleReset} className="reg__clean mt-2">Очистить</a>
                  </div>
                </React.Fragment>
              )}
            />
          </div>
        </div>
      </div> ) : (
        <InstructionsForRegistration />
      )}

      {/* {isModalVisible &&
        <React.Fragment>
          <div className="modal fade show" role="dialog" id="exampleModalSuccess" style={{ display: 'block'}}>
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                      <span aria-hidden="true">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M12.377 10.0001L19.5077 2.86931C20.1641 2.21291 20.1641 1.14869 19.5077 0.492389C18.8513 -0.164005 17.7872 -0.164005 17.1308 0.492389L9.99999 7.62323L2.86914 0.492296C2.21275 -0.164099 1.14862 -0.164099 0.492225 0.492296C-0.164075 1.14869 -0.164075 2.21291 0.492225 2.86921L7.62306 9.99996L0.492225 17.1308C-0.164075 17.7872 -0.164075 18.8514 0.492225 19.5077C1.14862 20.1641 2.21275 20.1641 2.86914 19.5077L9.99999 12.3769L17.1308 19.5077C17.7871 20.1641 18.8513 20.1641 19.5077 19.5077C20.1641 18.8513 20.1641 17.7872 19.5077 17.1308L12.377 10.0001Z" fill="white"/>
                        </svg>
                      </span>
                    </button>
                </div>
                <div className="modal-body text-center">
                      <span className="text-center">
                          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.9683 35.1289C18.1293 35.362 18.3938 35.4946 18.6731 35.4946C18.7311 35.4946 18.7905 35.4732 18.8494 35.4615C18.8921 35.4684 18.9336 35.4894 18.9768 35.4894C19.2277 35.4894 19.4717 35.3807 19.6427 35.1922L38.6319 16.2C38.9744 15.8579 38.9744 15.3028 38.6319 14.9602C38.2897 14.6181 37.7347 14.6181 37.3925 14.9602L18.8371 33.5182L12.5793 27.2617C12.2372 26.9191 11.6821 26.9191 11.3399 27.2617C10.9974 27.6038 10.9974 28.1589 11.3399 28.5015L17.9683 35.1289Z" fill="#FFD800"/>
                          <path d="M25 0C11.215 0 0 11.215 0 25C0 38.785 11.215 50 25 50C38.785 50 50 38.785 50 25C50 11.215 38.785 0 25 0ZM25 48.3333C12.1342 48.3333 1.66667 37.8658 1.66667 25C1.66667 12.1342 12.1342 1.66667 25 1.66667C37.8658 1.66667 48.3333 12.1342 48.3333 25C48.3333 37.8658 37.8658 48.3333 25 48.3333Z" fill="#FFD800"/>
                          </svg>
                      </span>
                      <h3 className="text-center mt-3 mt-md-4 mb-md-1 mb-0">{getTip(1)(tips)}</h3>
                       <span className="success-span">Доп текст тут</span>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </React.Fragment>
      } */}
    </React.Fragment>
  );
};

const mapStateToProps = ({ user, app }: IRootState) => ({
  tips: app.tips,
  userRole: user.role_id!,
});

export default connect(mapStateToProps)(RegistrationPage);
